import React from 'react';
import { useSelector } from 'react-redux';
import classes from './footer.module.css';
import { getFooterStatus } from '../../../../redux/footerReducer';
import mediaschoolLogo from '../../../assets/images/logotypes/mediaschool-logo.png';
import nornikelLogo from '../../../assets/images/logotypes/nornikel-logo.png';
import gorodLogo from '../../../assets/images/logotypes/gorod-logo.png';

const Footer = () => {
    const isFooter = useSelector(getFooterStatus());

    return (
        <div
            className={
                classes.footerWrap + ' ' + (isFooter && classes.footerVisible)
            }
        >
            <a
                href='//vk.com/popovmedia'
                target='_blank'
                rel='noreferrer'
                title='Медиашкола Игоря Попова в ВК'
                className={classes.mediaschool}
            >
                <img src={mediaschoolLogo} alt='Медиашкола - logo' />
            </a>
            <a
                href='https://nornickel.ru/'
                title='Компания «Норникель»'
                target='_blank'
                rel='noreferrer'
                className={classes.nornikel}
            >
                <img src={nornikelLogo} alt='Норникель - logo' />
            </a>
            <a
                href='https://sgnorilsk.ru/'
                title='Медиакомпания «Северный город»'
                target='_blank'
                rel='noreferrer'
                className={classes.gorod}
            >
                <img src={gorodLogo} alt='Северный город - logo' />
            </a>
            {/*<div className={classes.addresses}>*/}
            {/*    <p>Наш адрес: 663302, Красноярский край, </p>*/}
            {/*    <p>г. Норильск, ул. Комсомольская, д. 33А</p>*/}
            {/*    <p>E-mail: test@test.com </p>*/}
            {/*</div>*/}
        </div>
    );
};

export default Footer;
